module.exports = __webpack_public_path__ + "static/media/boxSeat.2fc3beea.png";